export interface HistoricalPerformance {
  name: string;
  id: number;
  market: string;
  monthsHeld: number;
  totalReturns: number;
  appreciationReturns: number | null;
  rentalIncomeReturns: number;
  sharePrice: number;
}

export const historicalPerformanceData = `name,id,market,monthsHeld,appreciationReturns,rentalIncomeReturns,totalReturns,sharePrice
Lierly,1,Northwest Arkansas,19,1.0790,0.0754,1.1990,20.79
Soapstone,2,Northwest Arkansas,19,0.9870,0.0674,1.0940,19.87
Pecan,3,Northwest Arkansas,19,0.4670,0.0674,0.5770,14.67
Patrick,4,Northwest Arkansas,19,0.2480,0.0595,0.3530,12.48
Plumtree,5,Northwest Arkansas,19,0.3940,0.0793,0.5260,13.94
Chaparral,6,Northwest Arkansas,19,0.3390,0.0714,0.4590,13.39
Splash,7,Northwest Arkansas,14,0.3460,0.0714,0.4430,13.46
Tuscan,8,Northwest Arkansas,14,0.1870,0.0714,0.2840,11.87
Salem,10,Northwest Arkansas,14,0.3850,0.0674,0.4810,13.85
Malbec,11,Northwest Arkansas,14,0.2720,0.0714,0.3690,12.72
Pinot,12,Northwest Arkansas,14,0.2570,0.0714,0.3540,12.57
Luna,13,Columbia,14,0.4380,0.0635,0.5250,14.38
Kingsley,14,Columbia,14,0.2900,0.0595,0.3750,12.90
Shoreline,15,Greenville-Spartanburg,14,0.2130,0.0595,0.2860,12.13
Holloway,16,Greenville-Spartanburg,14,0.3190,0.0595,0.3970,13.19
Badminton,17,Columbia,14,0.3790,0.0595,0.4540,13.79
Eastfair,18,Columbia,14,0.3980,0.0635,0.4750,13.98
Centennial,19,Charlotte,14,0.3160,0.0476,0.3910,13.16
Mojave,20,Northwest Arkansas,14,0.2060,0.0714,0.2940,12.06
Wentworth,21,Northwest Arkansas,14,0.2020,0.0754,0.2910,12.02
Cupcake,22,Northwest Arkansas,14,0.3890,0.0754,0.4780,13.89
Basil,23,Greenville-Spartanburg,14,0.2600,0.0595,0.3330,12.60
Lallie,24,Charleston,14,0.2520,0.0476,0.3210,12.52
Dewberry,25,Columbia,14,0.2410,0.0516,0.3180,12.41
Spencer,26,Charleston,14,0.3300,0.0595,0.4130,13.30
Summerset,27,Charleston,14,0.3240,0.0476,0.3930,13.24
Roseberry,35,Charleston,14,0.2250,0.0516,0.3000,12.25
Windsor,36,Charleston,14,0.2590,0.0595,0.3320,12.59
Forest,37,Charleston,11,0.1750,0.0476,0.2260,11.75
Meadow,40,Charlotte,11,0.0730,0.0317,0.1070,10.73
Collinston,41,Charlotte,11,0.1670,0.0317,0.2010,11.67
Saddlebred,42,Colorado Springs,11,-0.0860,0.0357,-0.0450,9.14
Odessa,43,Denver,11,0.0020,0.0357,0.0430,10.02
Lily,44,Colorado Springs,11,-0.0620,0.0357,-0.0210,9.38
Saturn,45,Charlotte,11,0.2050,0.0317,0.2390,12.05
Sugar,46,Charleston,11,0.2170,0.0357,0.2550,12.17
Coatbridge,47,Columbia,11,0.1670,0.0516,0.2190,11.67
Lennox,48,Columbia,11,0.1170,0.0595,0.1720,11.17
Olive,49,Columbia,11,0.0180,0.0555,0.0720,10.18
Dawson,50,Columbia,11,0.1240,0.0516,0.1760,11.24
Ridge,51,Columbia,11,0.2180,0.0555,0.2720,12.18
Bayside,52,Columbia,11,0.2730,0.0595,0.3280,12.73
Elm,53,Columbia,11,0.3270,0.0516,0.3790,13.27
River,54,Greenville-Spartanburg,11,0.3380,0.0595,0.3930,13.38
Amber,55,Charlotte,11,0.1400,0.0357,0.1760,11.40
Westchester,56,Columbia,11,0.2070,0.0516,0.2590,12.07
Limestone,57,Columbia,11,0.2710,0.0595,0.3260,12.71
Jupiter,58,Charlotte,11,0.1890,0.0357,0.2250,11.89
Weldon,59,Charlotte,11,0.2300,0.0317,0.2640,12.30
Holland,60,Charlotte,11,0.1780,0.0317,0.2130,11.78
Elevation,61,Greenville-Spartanburg,11,0.3250,0.0476,0.3760,13.25
Oly,62,Denver,10,0.1470,0.0436,0.1910,11.47
McLovin,63,Denver,10,0.0890,0.0436,0.1330,10.89
Matchingham,64,Columbia,10,0.2630,0.0595,0.3180,12.63
Rooney,65,Phoenix,10,0.0760,0.0357,0.1170,10.76
Diablo,66,Tucson,10,0.0820,0.0357,0.1210,10.82
KerriAnn,67,Raleigh-Durham,9,0.1060,0.0317,0.1430,11.06
Sigma,68,Raleigh-Durham,10,0.0000,0.0397,0.0401,10.00
Grant,69,Atlanta,10,0.2960,0.0476,0.3440,12.96
Bandelier,70,Tucson,10,0.1390,0.0317,0.1760,11.39
Ensenada,71,Denver,10,0.0920,0.0436,0.1360,10.92
Davidson,72,Charlotte,10,0.2100,0.0317,0.2440,12.10
Vernon,73,Greenville-Spartanburg,10,0.1100,0.0436,0.1590,11.10
Murphy,74,Columbia,10,0.3140,0.0555,0.3650,13.14
Dolittle,75,Columbia,10,0.2560,0.0476,0.3040,12.56
Butter,76,Charleston,10,0.1130,0.0516,0.1650,11.13
Ribbonwalk,77,Charlotte,10,0.1220,0.0317,0.1560,11.22
Scepter,78,Tucson,10,0.2850,0.0317,0.3220,12.85
Delta,80,Atlanta,9,-0.0600,0.0436,-0.0170,9.40
Saint,81,Tucson,9,0.1310,0.0476,0.1710,11.31
Lovejoy,82,Atlanta,9,0.1240,0.0476,0.1680,11.24
Emporia,83,Atlanta,9,0.0620,0.0436,0.1050,10.62
Wave,84,Atlanta,9,0.0400,0.0436,0.0830,10.40
Tuxford,85,Columbia,9,-0.0300,0.0436,0.0150,9.70
Greenhill,86,Columbia,9,0.1820,0.0516,0.2300,11.82
Kawana,87,Huntsville,9,0.0530,0.0476,0.1000,10.53
Chelsea,88,Birmingham,8,-0.0300,0.0476,0.0060,9.70
Terracotta,89,Tucson,9,0.0350,0.0516,0.0710,10.35
Otoro,90,Atlanta,9,0.0320,0.0436,0.0670,10.32
Hollandaise,91,Nashville,9,-0.0560,0.0397,-0.0270,9.44
Hadden,92,Greenville-Spartanburg,9,0.1040,0.0555,0.1460,11.04
Avebury,93,Huntsville,9,0.0660,0.0436,0.0990,10.66
Tulip,94,Tuscaloosa,8,-0.1330,0.0476,-0.0950,8.67
Jack,95,Nashville,8,0.1150,0.0357,0.1420,11.15
Bedford,96,Columbia,8,0.1670,0.0516,0.2030,11.67
Louise,97,Tuscaloosa,8,-0.0830,0.0555,-0.0410,9.17
Gardens,98,Tuscaloosa,7,-0.1580,0.0436,-0.1250,8.42
Peanut,99,Tuscaloosa,8,-0.1460,0.0397,-0.1160,8.54
100,100,Nashville,6,-0.0460,0.0436,-0.0190,9.54
Grove,101,Birmingham,7,-0.0920,0.0357,-0.0700,9.08
Lanier,102,Atlanta,7,0.1040,0.0317,0.1250,11.04
Mammoth,103,Atlanta,7,0.0180,0.0317,0.0390,10.18
McGregor,104,Clarksville,7,-0.0070,0.0397,0.0190,9.93
Point,105,Clarksville,7,0.0560,0.0397,0.0800,10.56
Roxy,106,Clarksville,7,-0.1040,0.0317,-0.0830,8.96
Wisteria,107,Tuscaloosa,7,-0.0250,0.0397,0.0000,9.75
Heron,108,Charleston,7,0.0350,0.0357,0.0570,10.35
Stonebriar,109,Birmingham,7,-0.0650,0.0357,-0.0410,9.35
Heritage,110,Atlanta,7,-0.0570,0.0317,-0.0360,9.43
Magnolia,111,Atlanta,7,-0.1340,0.0317,-0.1130,8.66
Kirkwood,112,Clarksville,7,0.0200,0.0317,0.0410,10.20
Rosewood,113,Tuscaloosa,7,-0.0690,0.0317,-0.0480,9.31
Apollo,114,Huntsville,6,0.0140,0.0317,0.0350,10.14
Baron,115,Denver,6,-0.1320,0.0357,-0.1090,8.68
Swift,116,Atlanta,6,-0.0040,0.0397,0.0230,9.96
Wescott,117,Clarksville,6,-0.0490,0.0317,-0.0280,9.51
Wildwood,118,Chattanooga,6,-0.0310,0.0357,-0.0080,9.69
Madison,119,Huntsville,6,0.0130,0.0357,0.0370,10.13
Abbington,120,Nashville,6,-0.0850,0.0357,-0.0620,9.15
Burlington,121,Denver,6,-0.0580,0.0357,-0.0350,9.42
Lannister,122,Tuscaloosa,6,-0.1100,0.0357,-0.0880,8.90
Nugget,123,Denver,6,-0.1000,0.0357,-0.0770,9.00
Pearl,124,Nashville,6,0.0140,0.0397,0.0380,10.14
Hines,125,Clarksville,6,-0.0160,0.0357,0.0020,9.84
Ritter,126,Colorado Springs,5,0.0000,0.0317,0.0160,10
101,127,Nashville,6,-0.0500,0.0317,-0.0340,9.50
Jake,128,Denver,6,-0.0650,0.0317,-0.0490,9.35
Holcomb,129,Atlanta,6,-0.0210,0.0317,-0.0050,9.79
Latte,130,Birmingham,5,0.0000,0.0317,0.0160,10
Dunbar,131,Clarksville,5,0.0000,0.0317,0.0160,10
Lookout,132,Chattanooga,5,0.0000,0.0317,0.0160,10
Reynolds,133,Atlanta,6,-0.0750,0.0317,-0.0590,9.25
Kennesaw,134,Atlanta,6,-0.0710,0.0317,-0.0550,9.29
Pioneer,135,Denver,6,-0.0750,0.0278,-0.0600,9.25
Bazzel,136,Greenville-Spartanburg,5,0.0000,0.0317,0.0160,10
June,137,Nashville,5,0.0000,0.0357,0.0180,10
Johnny,138,Nashville,5,0.0000,0.0357,0.0180,10
Osprey,139,Charleston,6,-0.0240,0.0317,-0.0080,9.76
Riverwalk,140,Chattanooga,5,0.0000,0.0357,0.0180,10
Collier,141,Knoxville,5,0.0000,0.0357,0.0180,10
Folly,142,Charleston,5,0.0000,0.0317,0.0160,10
Dorchester,143,Charleston,5,0.0000,0.0317,0.0160,10
Dogwood,144,Tuscaloosa,5,0.0000,0.0357,0.0170,10
Walton,145,Northwest Arkansas,5,0.0000,0.0317,0.0160,10
Clover,146,Huntsville,5,0.0000,0.0397,0.0190,10
Dolly,147,Nashville,4,0.0000,0.0317,0.0160,10
Kenny,148,Nashville,4,0.0000,0.0317,0.0160,10
Creekside,149,Northwest Arkansas,4,0.0000,0.0397,0.0190,10
Willow,150,Northwest Arkansas,4,0.0000,0.0357,0.0170,10
Wilson,151,Northwest Arkansas,4,0.0000,0.0357,0.0170,10
Daisy,152,Northwest Arkansas,4,0.0000,0.0357,0.0170,10
Henry,153,Atlanta,4,0.0000,0.0357,0.0180,10
Sodalis,154,Indianapolis,4,0.0000,0.0317,0.0160,10
Loretta,155,Nashville,2,0.0000,0.0357,0.0180,10
Conway,156,Nashville,3,0.0000,0.0357,0.0180,10
Belle,157,Atlanta,4,0.0000,0.0317,0.0160,10
Chitwood,158,Cincinnati,4,0.0000,0.0357,0.0170,10
Spring,159,Greenville-Spartanburg,4,0.0000,0.0357,0.0170,10
Highland,160,Greenville-Spartanburg,4,0.0000,0.0357,0.0180,10
Wellington,161,Atlanta,2,0.0000,0.0317,0.0080,10
Braxton,162,Cincinnati,0,0.0000,0.0516,0.0130,10
Reginald,163,Atlanta,3,0.0000,0.0357,0.0180,10
Camino,164,Tuscaloosa,3,0.0000,0.0397,0.0190,10
Winston,165,Huntsville,2,0.0000,0.0317,0.0080,10
Inglewood,166,Nashville,1,0.0000,0.0317,0.0080,10
Richardson,167,Northwest Arkansas,1,0.0000,0.0317,0.0160,10
Cumberland,168,Clarksville,4,0.0000,0.0357,0.0170,10
Bonneau,169,Charleston,4,0.0000,0.0317,0.0160,10
Blossom,170,Northwest Arkansas,1,0.0000,0.0397,0.0100,10
Marcelo,171,Cincinnati,0,0.0000,0.0397,0.0100,10
Taylor,172,Tuscaloosa,1,0.0000,0.0238,0.0060,10
Aster,173,Northwest Arkansas,3,0.0000,0.0238,0.0120,10
Quincy,174,Denver,2,0.0000,0.0317,0.0080,10
Jill,175,Nashville,1,0.0000,0.0317,0.0080,10
Marietta,176,Greenville-Spartanburg,4,0.0000,0.0357,0.0180,10
Mae,177,Greenville-Spartanburg,2,0.0000,0.0357,0.0090,10
Chester,178,Chattanooga,2,0.0000,0.0198,0.0050,10
Shallowford,179,Chattanooga,1,0.0000,0.0317,0.0080,10
Cypress,180,Atlanta,3,0.0000,0.0238,0.0120,10
Harrison,181,Chattanooga,3,0.0000,0.0278,0.0130,10
Piedmont,182,Atlanta,2,0.0000,0.0198,0.0050,10
Kessler,183,Northwest Arkansas,2,0.0000,0.0198,0.0050,10
Creekwood,184,Huntsville,2,0.0000,0.0198,0.0050,10
Oasis,185,Nashville,2,0.0000,0.0436,0.0110,10
Pointbreak,186,Panama City,2,0.0000,0.0397,0.0100,10
Hammock,187,Clearwater,2,0.0000,0.0476,0.0120,10
Ace,188,Scottsdale,1,0.0000,0.0516,0.0130,10
Cardinal,189,Phoenix,2,0.0000,0.0397,0.0100,10
Orchard,190,Blue Ridge,2,0.0000,0.0476,0.0120,10
Mirage,191,Joshua Tree,2,0.0000,0.0397,0.0100,10
Hansel,192,Nashville,1,0.0000,0.0317,0.0080,10
Falcon,193,Northwest Arkansas,1,0.0000,0.0357,0.0090,10
Eagle,194,Northwest Arkansas,2,0.0000,0.0397,0.0100,10
Goose,195,Northwest Arkansas,1,0.0000,0.0436,0.0110,10
Cactus,196,Scottsdale,1,0.0000,0.0357,0.0090,10
Opry,197,Nashville,1,0.0000,0.0357,0.0090,10
Mimosa,199,Tuscaloosa,0,0.0000,0.0397,0.0100,10
Redondo,200,Albuqurque ,1,0.0000,0.0317,0.0080,10
Sundance,201,Albuqurque ,0,0.0000,0.0317,0.0080,10
Serenity,203,Sedona,0,0.0000,0.0516,0.0130,10
Sugarcreek,204,Blue Ridge,0,0.0000,0.0436,0.0110,10
Palm,205,Palm Beach,1,0.0000,0.0397,0.0100,10`;
